/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IDefaContentTileViewProps } from './defa-content-tile';

export default (props: IDefaContentTileViewProps) => {
    const {
        baseClassName,
        backgroundImage,
        heading,
        content,
        actionLink
    } = props;

    return (
        <Module {...props.contentTile}>
            <div className={`${baseClassName}__background-image-wrapper`}>
                {backgroundImage}
            </div>
            <div className={`${baseClassName}__overlay`}>
                {heading}
                {content}
                {actionLink}
            </div>
        </Module>
    );
};
